import { useTranslation } from 'react-i18next';

import type { StreamType } from '~/components/LineGraph/LineGraph';
import type { DSPData } from '~/modules/artist-roster/components/TrackDetails/mockData/mockData';

import { BarChartTooltip } from '../BarChartTooltip';
import { DSPIcon } from './DSPIcon';

interface DSPTooltipProps {
  dsp: string;
  data: DSPData;
  totalStreams: number;
  streamType: StreamType;
}

export function DSPTooltip(props: DSPTooltipProps) {
  const { t } = useTranslation('names');

  return (
    <BarChartTooltip
      header={
        <>
          <DSPIcon type={props.dsp} className="w-lg" />
          {t(props.dsp)}
        </>
      }
      {...props}
    />
  );
}

DSPTooltip.displayName = 'DSPTooltip';
